import React from "react";
import Contact from "../sections/Contact";

function ContactPage() {
  return (
    <div className="contact-page">
      <Contact />
    </div>
  );
}

export default ContactPage;
